import { Component, OnInit } from '@angular/core';

import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DataSharingService } from '../../../auth/data-sharing.service';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';

import { NgForm } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';




@Component({
  selector: 'app-enlistuser',
  templateUrl: './enlistuser.component.html',
  styleUrls: ['./enlistuser.component.css']
})
export class EnlistuserComponent implements OnInit {


  // smgMasterList : any;
  // ssgMasterList : any;
  selectedSmgId: any = [];
  selectedSmgIdString: string = "";
  // mfData: any;
  // mfRowsOnPage: number;
  // mfActivePage: number;
  // mfSortBy: any;
  // mfSortOrder: string;
  showSmgMaster: boolean = false;
  showEnlistmentForm: boolean = false;
  completedRegister: boolean = false;

  data: any;
  ssgdata: any;
  smgdata: any;
  preVendor: Prevendor;

  requiredFlds: boolean = false;
  requiredCond: boolean = false;
  wrongEmail: boolean = false;
  usernameTaken: boolean = false;

  isLoading: boolean = false;
  staticText: string;

  selectedSsgId: any = [];
  selectedSsgIdString: string = "";
  otherMaterial: string = "";
  currencyData: any;
  @ViewChild('submitSmgIdBtn', { static: false }) submitSmgIdBtn: ElementRef;
  @ViewChild('registerVendorBtn', { static: false }) registerVendorBtn: ElementRef;
  @ViewChild('otherItem', { static: false }) otherItem: ElementRef;


  constructor(public router: Router, private route: ActivatedRoute, private dataSharingService: DataSharingService,
    private enlistServices: EnlistmentService) { }

  ngOnInit() {
    this.showSmgMaster = true;
    this.getSMGMasterList();
    this.getSSGMasterList();
    this.preVendor = new Prevendor();

    this.enlistServices.getStaticData().subscribe(
      (data: any) => {
        this.staticText = data;
        console.log(this.staticText);
      }
    )

  }

  ngAfterViewInit() {
    this.submitSmgIdBtn.nativeElement.disabled = true;
  }


  getSMGMasterList() {
    this.enlistServices.getSMGMasterList().subscribe(
      data => {
        this.smgdata = data;
        // console.log(this.data);
      }
    )
  }

  getSSGMasterList() {
    this.enlistServices.getSSGMasterList().subscribe(
      data => {
        this.ssgdata = data;
        // console.log(this.data);
      }
    )
  }

  smgCategory(keyword) {
    this.enlistServices.smgcategorysearch(keyword).subscribe(
      (data) => {
        this.smgdata = data;
        console.log(data);
      }
    );
  }

  ssgCategory(keyword) {
    this.enlistServices.ssgcategorysearch(keyword).subscribe(
      (data) => {
        this.ssgdata = data;
        console.log(data);
      }
    )
  }

  smgCheck(ev) {

    if (ev.target.checked) {
      this.selectedSmgId.push(ev.target.defaultValue);
    }
    else {
      var index = this.selectedSmgId.indexOf(ev.target.defaultValue);
      if (index > -1) {
        this.selectedSmgId.splice(index, 1);
      }
    }

    if (this.selectedSmgId.length > 0 || this.selectedSsgId.length > 0) {
      this.submitSmgIdBtn.nativeElement.disabled = false;
    }
    else {
      this.submitSmgIdBtn.nativeElement.disabled = true;
    }

  }
  // getCurrency() {
  //   debugger;
  //   this.projectdetails.GetCurrencyData().subscribe(
  //     data => {
  //       this.currencyData = data;
  //       console.log(this.currencyData.UserId);
  //     }
  //   )
  // }
  ssgCheck(ev) {

    if (ev.target.checked) {
      this.selectedSsgId.push(ev.target.defaultValue);
    }
    else {
      var index = this.selectedSsgId.indexOf(ev.target.defaultValue);
      if (index > -1) {
        this.selectedSsgId.splice(index, 1);
      }
    }

    if (this.selectedSsgId.length > 0 || this.selectedSmgId.length > 0) {
      //this.submitSsgIdBtn.nativeElement.disabled = false;
      this.submitSmgIdBtn.nativeElement.disabled = false;
    }
    else {
      //this.submitSsgIdBtn.nativeElement.disabled = true;
      this.submitSmgIdBtn.nativeElement.disabled = true;
    }

  }

  submitSmgId() {
    // console.log(this.selectedSmgId);
debugger;
    this.showSmgMaster = false;
    this.showEnlistmentForm = true;
    this.completedRegister = false;

    for (var i = 0; i < this.selectedSmgId.length; i++) {
      this.selectedSmgIdString = this.selectedSmgIdString + this.selectedSmgId[i];
      if (i < this.selectedSmgId.length - 1) {
        this.selectedSmgIdString = this.selectedSmgIdString + ",";
      }
    }

    for (var i = 0; i < this.selectedSsgId.length; i++) {
      this.selectedSsgIdString = this.selectedSsgIdString + this.selectedSsgId[i];
      if (i < this.selectedSsgId.length - 1) {
        this.selectedSsgIdString = this.selectedSsgIdString + ",";
      }
    }

    // console.log(this.selectedSmgIdString);
    // console.log(this.selectedSsgIdString);
    // console.log(this.otherItem.nativeElement.value);

    //alert(this.selectedSmgIdString);

    if(this.otherItem.nativeElement.value)
    {
      //alert("value exist");
      this.otherMaterial = this.otherItem.nativeElement.value;
      //alert(this.otherMaterial);
    }
  }

  SubmitEnlistmentForm(form: NgForm) {
    this.isLoading = true;
    this.requiredCond = false;
    this.requiredFlds = false;
    this.wrongEmail = false;
    this.usernameTaken = false;

    console.log(form.value);
    //this.registerVendorBtn.nativeElement.disabled = true;

    var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

    if (form.value.companyName.trim().length != 0 && form.value.address.trim().length != 0 &&
      form.value.city.trim().length != 0 && form.value.contactPersonName.trim().length != 0 &&
      form.value.email.trim().length != 0 && form.value.mobileNo != "" && form.value.pinCode != "" &&
      form.value.state.trim().length != 0 && form.value.country.trim().length != 0) {

      if (regexEmail.test(form.value.email)) {
        if (1==1) {
          form.value.countryId = 1;
          form.value.sMG_Nos = this.selectedSmgIdString;
          form.value.sSG_Nos = this.selectedSsgIdString;
          form.value.otherMaterialService = this.otherMaterial;
          //alert(form.value.otherMaterialService);
          //form.value.vendorType = "smg";

          // if (form.value.natureOfBusiness == 1) {
          //   form.value.natureOfBusiness = "Manufacturer";
          //   form.value.natureOfBusinessId = 1;
          // }
          // else if (form.value.natureOfBusiness == 2) {
          //   form.value.natureOfBusiness = "Dealer (Materials Supply)";
          //   form.value.natureOfBusinessId = 2;
          // }
          // else if (form.value.natureOfBusiness == 3) {
          //   form.value.natureOfBusiness = "Dealer (Services)";
          //   form.value.natureOfBusinessId = 3;
          // }
          // else if (form.value.natureOfBusiness == 4) {
          //   form.value.natureOfBusiness = "Service Contractor";
          //   form.value.natureOfBusinessId = 4;
          // }
          // else { }

          this.enlistServices.registerVendorUser(form.value).subscribe(
            (data) => {
              if (data == true) {
                this.isLoading = false;
                this.showSmgMaster = false;
                this.showEnlistmentForm = false;
                this.completedRegister = true;
              }
              else {
                this.isLoading = false;
                this.usernameTaken = true;
                window.scroll(0, 0);
              }
            }
          );


        }
        else {
          this.isLoading = false;
          this.requiredCond = true;
          window.scroll(0, 0);
        }
      }
      else {
        this.isLoading = false;
        this.wrongEmail = true;
        window.scroll(0, 0);
      }


    }
    else {
      this.isLoading = false;
      this.requiredFlds = true;
      window.scroll(0, 0);

    }

    //this.registerVendorBtn.nativeElement.disabled = false;

  }



}
